import type {QueryParam} from '@/modules/common/context/QueryParams/models';

export const isValidUrlEntry = (key: QueryParam, value: string): boolean => {
  return (
    // don't include empty parameters in URL since they carry no meaning
    value.length > 0 &&
    // new links should not contain these, "rooms" already has the information
    key !== 'adults' &&
    key !== 'children' &&
    // new links should not contain these, "roomAttributes" already has the information
    key !== 'roomViews'
  );
};
